import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Header, Text } from '../../../../ui-components';
import { CategoryLinks } from '../category-links';
import type { Block } from '../../../../components/sfcc-content-rendering/Blocks';

interface RecipeCategoryHeaderProps {
    categoryName?: string;
    categorySlots?: Record<string, Block[]>;
    currentPathname: string;
}

/**
 * Renders the header section for recipe category pages.
 * Displays the category name, subtitle, and navigation links.
 * @param categoryName - The name of the recipe category
 * @param categorySlots - Content slots containing category navigation data
 * @param currentPathname - Current page path for highlighting active category
 */
export const RecipeCategoryHeader: FC<RecipeCategoryHeaderProps> = ({
    categoryName,
    categorySlots,
    currentPathname,
}) => (
    <div className="relative inset-x-1/2 mx-[-50vw] w-screen bg-slt-deco-purple-50 py-6">
        <div className="mx-auto flex max-w-[1928px] flex-col items-center justify-center gap-4 px-4 sm:px-8 lg:px-10 xl:px-16">
            <div className="flex flex-col items-center gap-1">
                <Header
                    id="search.results.for.category"
                    color="slt-pepper.1000"
                    as="h1"
                    variant="header3"
                    style="bold"
                >
                    {categoryName}
                </Header>
                <Text size="base" type="body" style="bold">
                    <FormattedMessage
                        id="recipes.subtitle"
                        defaultMessage="Tested, loved, and easy to make your own"
                    />
                </Text>
            </div>
            <CategoryLinks
                categorySlots={categorySlots}
                slotId="recipe-listing-slot-1"
                currentPathname={currentPathname}
            />
        </div>
    </div>
);

RecipeCategoryHeader.displayName = 'RecipeCategoryHeader';
